import { apiService } from '../api';

const ENDPOINTS = {
    SEO_LINKED_WEBSITES_GET: '/seo-linked-websites/:websiteId',
    SEO_LINKED_WEBSITES_UPDATE: '/seo-linked-websites',
}

class SeoLinkedWebesitesService {
    async getSeoLinkedWebsites(websiteId) {
      return await apiService.get(ENDPOINTS.SEO_LINKED_WEBSITES_GET.replace(':websiteId', websiteId));
    }

    async updateSeoLinkedWebsites(payload) {
      const res = await apiService.put(
          ENDPOINTS.SEO_LINKED_WEBSITES_UPDATE,
          payload
      );
      return res.data;
    }

    prepareSeoLinkedWebsitesDataFromResponse(items) {
        const seoLinkedWebsites = [];

        items.forEach(website => {
          seoLinkedWebsites.push({'rowData': {
            id: website.id,
            websiteSourceName: website.websiteSource.name,
            websiteTargetName: website.websiteTarget.name,
            websiteSourceId: website.websiteSourceId,
            websiteTargetId: website.websiteTargetId,
            position: website.position,
            xDefault: website.xDefault,
            includePages: website.includedPages || [] 
            }
          });
        });

        return seoLinkedWebsites;
    }
}

export const seoLinkedWebesitesService = new SeoLinkedWebesitesService();